import styled, { keyframes } from 'styled-components'
import { CSS } from 'ui/helpers'

const slideIn = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

export const WidgetContainer = styled.div<{ $expanded: boolean }>`
  position: fixed;
  bottom: 40px;
  right: 50px;
  width: 360px;

  display: flex;
  flex-direction: column;
  overflow: hidden;

  max-height: ${(p) => (p.$expanded ? '440px' : 'auto')};
  border-radius: ${(p) => p.theme.uiKit.borderRadius.roundedModal};

  background: ${(p) => p.theme.uiKit.colors.global.general.main};

  box-shadow: ${(p) => CSS.populateBoxShadow(p.theme.uiKit.boxShadows.offset.offset100Y8)};
  z-index: 9999;

  animation: ${slideIn} 0.7s ease-out;
`

const FileList = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

const EmptyState = styled.div`
  padding: 24px;
  text-align: center;
  color: #999;
  font-size: 14px;
`

export const s = {
  WidgetContainer,
  FileList,
  EmptyState
}
